// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: every spinner in the app is the Konvo loader. The Spinner API stays
// so the call sites do not change.

import {KonvoLoader} from '@app/features/ui/components/KonvoLoader';
import styles from '@app/features/ui/components/Spinner.module.css';
import {Trans} from '@lingui/react/macro';
import {clsx} from 'clsx';
import {observer} from 'mobx-react-lite';

interface SpinnerProps {
	className?: string;
	size?: 'small' | 'medium' | 'large';
}

export const Spinner = observer(function Spinner({className, size = 'medium'}: SpinnerProps) {
	return (
		<span className={clsx(styles.spinner, className)} data-flx="ui.spinner.spinner">
			<KonvoLoader size={size} data-flx="ui.spinner.spinner-inner" />
			<span className={styles.srOnly} data-flx="ui.spinner.sr-only">
				<Trans>Loading…</Trans>
			</span>
		</span>
	);
});
